var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showModal,
      expression: "showModal"
    }],
    class: [{
      'modal-mask-progress': _vm.showProgress,
      'modal-mask': !_vm.showProgress
    }],
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "aria-labelledby": "dialog-title",
      "aria-describedby": "dialog-description",
      "aria-modal": "true"
    }
  }, [_c('div', {
    class: [{
      'modal-wrapper-progress': _vm.showProgress,
      'modal-wrapper': !_vm.showProgress,
      'modal-video-wrapper': _vm.showPlayer
    }]
  }, [_c('div', {
    class: [{
      'modal-container-progress': _vm.showProgress,
      'modal-container': !_vm.showProgress
    }]
  }, [_c('div', {
    class: [{
      'modal-body-progress': _vm.showProgress,
      'modal-body': !_vm.showProgress
    }]
  }, [_vm.showPlayer ? _c('div', {
    staticClass: "video-player-container"
  }, [_c('video-player')], 1) : _vm._e(), _vm.showProgress ? _c('div', {
    staticClass: "progressScreen"
  }, [_c('progress-path')], 1) : _vm._e(), _vm.showCertificate ? _c('div', {
    staticClass: "certScreen"
  }, [_c('certificate')], 1) : _vm._e(), _vm.showError ? _c('div', {
    staticClass: "errorScreen"
  }, [_c('oops', {
    attrs: {
      "hide-tell-teacher": _vm.modalData && _vm.modalData.hideTellTeacher
    }
  })], 1) : _vm._e(), _vm.showKeyboardError ? _c('div', [_c('keyboard-error')], 1) : _vm._e(), _vm.showTextHelper ? _c('div', [_c('show-text-helper', {
    attrs: {
      "heading": _vm.modalData.heading,
      "text": _vm.modalData.text
    }
  })], 1) : _vm._e()])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }